export default `p=abs(p)-.1;
  return length(max(p,0.)+min(max(p.x,max(p.y,p.z)),0.));
}
float de(vec3 p){
  float s=2.,r=.7;
  vec3 o=p;
  for(int i=0;i<8;i++){
    p=clamp(p,-1.008,1.008)*2.03-p; 
    float l=cube(p);
    if(l<.5){p*=2.1;r*=2.1;}else if(l<3.8){p/=l;r/=l;} 
    p=o+p*s;r=r*abs(s)+1.;
  }
  return .25-length(p)/abs(r);
}`